"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClickOutside = void 0;
var react_1 = require("react");
function useClickOutside(handler, events) {
    if (events === void 0) { events = ['mousedown', 'touchstart']; }
    var ref = react_1.useRef();
    react_1.useEffect(function () {
        var listener = function (event) {
            if (ref.current && !ref.current.contains(event.target)) {
                handler();
            }
        };
        events.forEach(function (fn) { return document.addEventListener(fn, listener); });
        return function () {
            events.forEach(function (fn) { return document.removeEventListener(fn, listener); });
        };
    }, [ref, handler]);
    return ref;
}
exports.useClickOutside = useClickOutside;
